"use strict";
import { useContext } from "react";
import { HostModuleContext } from "../context";
export function useHostModule() {
  const info = useContext(HostModuleContext);
  return info;
}
